import type { PageType } from '@hotjar/navigation/src/types';

export const getPageType = (currentPathConfigName?: string): PageType => {
  // to make it consistent with the current nav, in case of a 404 page, the user should see the 'feature' menu
  if (!currentPathConfigName) {
    return 'feature';
  }

  const currentSection = currentPathConfigName.split('.')[0];

  if (['settings', 'site', 'team', 'sso'].includes(currentSection)) {
    return 'settings';
  }

  if (currentSection === 'profile') {
    return 'profile';
  }

  return 'feature';
};
